import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { CalendarSync, RefreshCw } from "lucide-react";
import { CalendarioPassi } from "@/components/CalendarioPassi";
import { CalendarioLink } from "@/components/CalendarioLink";

const SETTORI = [
  { key: "sportivo", label: "Sportivo", def: "#EA580C" },
  { key: "ritrattistica", label: "Ritrattistica", def: "#9333EA" },
];

export function CalendarioSync() {
  const { isTitolare } = useAuth();
  const [token, setToken] = useState("");
  const [colori, setColori] = useState(null);
  useEffect(() => { api.calLink().then((r) => setToken(r.token)).catch(() => {}); }, []);
  useEffect(() => {
    if (!isTitolare) return;
    Promise.all(SETTORI.map((s) => api.getSettingsOf(s.key)))
      .then((arr) => setColori(Object.fromEntries(arr.map((x, i) => [SETTORI[i].key, x.colore_calendario || SETTORI[i].def]))))
      .catch(() => setColori(Object.fromEntries(SETTORI.map((s) => [s.key, s.def]))));
  }, [isTitolare]);

  const salvaColore = async (settore, colore) => {
    await api.updateSettingsOf(settore, { colore_calendario: colore });
    setColori((c) => ({ ...c, [settore]: colore }));
    toast.success("Colore salvato: vale per i dispositivi che colleghi da adesso");
  };
  const rigenera = async () => {
    if (!window.confirm("I vecchi link smetteranno di funzionare e dovrai ricollegare il calendario su tutti i dispositivi. Continuare?")) return;
    const r = await api.calRigenera();
    setToken(r.token);
    toast.success("Nuovi link creati");
  };

  return (
    <Card className="p-6 animate-fade-up" data-testid="calendario-sync-card" id="calendario">
      <div className="flex items-center gap-2 mb-1">
        <CalendarSync className="h-5 w-5 text-primary" />
        <h2 className="text-lg font-semibold text-slate-900 dark:text-white">Calendario sul telefono e sul computer</h2>
        {token && <Button variant="ghost" size="sm" className="ml-auto text-xs text-slate-500" onClick={rigenera} data-testid="cal-regen-btn"><RefreshCw className="h-3.5 w-3.5 mr-1" />Nuovo link</Button>}
      </div>
      <p className="text-xs text-slate-500 mb-5">
        Si fa <b>una volta sola</b> per ogni dispositivo: da quel momento ogni evento creato, modificato o cancellato nell'app compare da solo nel calendario. Il link è personale: non condividerlo.
        {isTitolare && " Hai due calendari separati, uno per settore, ognuno con il suo colore: scegli i colori prima di collegarli (iPhone e Mac li usano in automatico; su Google il colore si sceglie a mano nel calendario)."}
      </p>
      {token && (isTitolare ? (
        colori && <div className="grid gap-3">{SETTORI.map((s) => (
          <CalendarioLink key={s.key} token={token} settore={s.key} label={`EFFERRE Photo – ${s.label}`} colore={colori[s.key]} onColore={(c) => salvaColore(s.key, c)} />
        ))}</div>
      ) : <CalendarioLink token={token} />)}
      <CalendarioPassi />
    </Card>
  );
}
